import React from 'react';
import { personalInfo } from '../data/mock';

const About = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="sobre" className="section-padding">
      <div className="container-custom">
        <div className="about-content">
          <div className="about-header">
            {personalInfo.profileImage && (
              <div className="about-image-wrapper">
                <img 
                  src={personalInfo.profileImage} 
                  alt="Tiago Cardoso"
                  className="about-image"
                />
              </div>
            )}
            <h2 className="section-title">Sobre mim</h2>
          </div>
          <div className="about-text">
            {personalInfo.about.split('\n\n').map((paragraph, index) => (
              <p key={index} className="about-paragraph">{paragraph}</p>
            ))}
          </div>
          <div className="about-cta">
            <button onClick={() => scrollToSection('casos')} className="btn-secondary">
              Ver casos na prática
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
